<!-- 查看销售订单页面-->
<template>
  <div class="business-content-main" v-loading="loading">
    <div>
      <div class="bread-nav">
        <breadcrumb :canBackHistory="true"></breadcrumb>
      </div>

      <div class="section-title">
        <div>
          <span>单据信息</span>
          <span style="font-size: 14px; color: red"
            >（ ※
            温馨提醒：如需要转化单据，需要优先关联/提取来源企业信息，然后关联/提取所有单据中的商品，才能操作单据转化
            ）</span
          >
        </div>
      </div>
      <div class="search-ctn">
        <el-form
          :model="orderData"
          ref="formMsg"
          label-width="100px"
          style="width: 100%; padding-right: 30px; padding-left: 30px"
        >
          <el-row :gutter="20">
            <el-col :span="5">
              <div class="grid-content bg-purple">
                <el-form-item label="单据类型">
                  <el-input
                    disabled
                    v-model="orderData.OrderTypeName"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="grid-content bg-purple">
                <el-form-item label="单号">
                  <el-input disabled v-model="orderData.OrderCode"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="5" v-if="!orderData.IsMine">
              <div class="grid-content bg-purple">
                <el-form-item label="来源企业">
                  <el-input disabled v-model="orderData.EntpCusName"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="9" v-if="!orderData.IsMine">
              <el-button
                class="search-btn"
                type="warning"
                v-if="
                  permission.edit && !orderData.IsMine && !orderData.IsCusRele
                "
                :title="
                  '关联已有的' + (type == 0 || type == 2 ? '供应商' : '客户')
                "
                @click="releEntps()"
                >关联{{
                  type == 0 || type == 2 ? "供应商" : "客户"
                }}档案</el-button
              >
              <el-button
                class="search-btn"
                type="warning"
                v-if="
                  permission.edit && !orderData.IsMine && !orderData.IsCusRele
                "
                :title="
                  '提取来源企业数据创建' +
                  (type == 0 || type == 2 ? '供应商档案' : '客户档案')
                "
                @click="tranEntps()"
                >提取{{
                  type == 0 || type == 2 ? "供应商" : "客户"
                }}档案</el-button
              >
              <el-button
                class="search-btn"
                type="warning"
                v-if="
                  permission.edit && !orderData.IsMine && orderData.IsCusRele
                "
                :title="
                  '重新关联已有的' +
                  (type == 0 || type == 2 ? '供应商' : '客户')
                "
                @click="reReleEntps()"
                >重新关联{{
                  type == 0 || type == 2 ? "供应商" : "客户"
                }}档案</el-button
              >
              <el-button
                class="search-btn btn-primary"
                v-if="
                  permission.edit && !orderData.IsMine && orderData.IsCusRele
                "
                title="提取来源企业的商品数据创建属于自己的库存商品"
                @click="tranOrders()"
                >转成{{ type == 0 || type == 2 ? "采购" : "销售"
                }}{{ type == 2 || type == 3 ? "售后单" : "订单" }}</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!--    table    -->
      <div class="section-title">
        <div>{{ title + "单号" }}：{{ orderData.OrderCode }}</div>
      </div>
      <!-- table body -->
      <div class="table-ctn">
        <el-table
          :header-cell-style="{ background: '#F2F6FC' }"
          :data="dataList"
          ref="multipleTable"
          :summary-method="getSummaries"
          show-summary
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            fixed="left"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            width="60px"
            type="index"
            label="序号"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            min-width="170px"
            prop="APCode"
            label="汽配编码"
          >
            <template slot-scope="scope">
              <div class="apcode-cell">
                <span>{{ scope.row.APCode }}</span>
                <el-tag
                  v-if="scope.row.State == 1"
                  class="tag"
                  type="warning"
                  size="small"
                  >已删除</el-tag
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            min-width="200px"
            prop="GoodName"
            label="配件名称"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            min-width="160px"
            prop="AutoSerise"
            label="车型"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            width="120px"
            prop="Count"
            :label="type == 2 || type == 3 ? '退货数量' : title + '数量'"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            width="100px"
            prop="Unit"
            label="单位"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            width="100px"
            prop="WarehousedCount"
            :label="type == 0 || type == 3 ? '已出仓数量' : '已入仓数量'"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            width="100px"
            prop="Price"
            :label="title + '价'"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            width="120px"
            prop="Total"
            :label="title + '总计'"
          >
            <template slot-scope="scope">{{
              (scope.row.Price * scope.row.Count).toFixed(2)
            }}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            width="100px"
            prop="IsRele"
            label="是否有关联"
            v-if="!orderData.IsMine"
          >
            <template slot-scope="scope">{{
              scope.row.IsRele ? "有关联" : "无关联"
            }}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            width="120px"
            prop="IsHaveSameCode"
            label="是否有相同编码"
            v-if="!orderData.IsMine"
          >
            <template slot-scope="scope">{{
              scope.row.IsHaveSameCode ? "有" : "无"
            }}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            min-width="120px"
            prop="MyAPCode"
            label="关联编码"
            ><template slot-scope="scope">
              <div
                style="color: #409eff"
                @click="showAPMsgDialog(scope.row.MyGoodsId)"
                type="text"
              >
                {{ scope.row.MyAPCode }}
              </div>
            </template></el-table-column
          >
          <el-table-column
            fixed="right"
            label="操作"
            width="100px"
            v-if="!orderData.IsMine"
          >
            <template slot="header">
              <el-tooltip effect="dark" placement="bottom">
                <div slot="content">
                  关联：对已有的库存商品进行关联 <br />
                  提取：提取来源企业的商品数据创建属于自己的库存商品
                </div>
                <span>
                  <i class="el-icon-warning-outline"></i>
                </span> </el-tooltip
              >操作
            </template>
            <template slot-scope="scope">
              <div class="ops-ctn">
                <el-button
                  type="text"
                  size="mini"
                  v-if="permission.edit && !scope.row.IsRele"
                  title="关联已有的库存商品"
                  @click="releGoods(scope.row)"
                  >关联</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  v-if="permission.edit && scope.row.IsRele"
                  title="重新关联已有的库存商品"
                  @click="reReleGoods(scope.row)"
                  style="color: orange"
                  >重新关联</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  v-if="permission.edit && !scope.row.IsRele"
                  title="提取来源企业的商品数据创建属于自己的库存商品"
                  @click="tranGoods(scope.row)"
                  >提取</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="bottom-div">
          <div class="ship-amount" v-if="orderData.ShipAmount > 0">
            运费
            <span class="discount-count"
              >+ ￥{{ (orderData.ShipAmount * 1).toFixed(2) }}</span
            >
          </div>
          <div class="ship-amount" v-if="orderData.ShipAmount > 0">
            优惠金额
            <span class="discount-count"
              >- ￥{{ (orderData.DiscountAmount * 1).toFixed(2) }}</span
            >
          </div>
          <div class="subzone" v-if="orderData.SurplusMoney > 0">
            <div class="part">
              <div>
                实{{
                  type == 2 || type == 3 ? "退" : type == 0 ? "收" : "付"
                }}金额
                <span class="discount-count"
                  >= ￥ {{ orderData.SurplusMoney }}</span
                >
              </div>
            </div>
          </div>
          <div
            class="subzone"
            v-if="(type == 2 || type == 3) && orderData.SurplusMoney == 0"
          >
            <div class="part">
              <div>
                <span class="discount-count">本售后单无需退款</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="提取商品信息"
      :visible.sync="tranAPVisible"
      width="1000px"
    >
      <div v-if="tranAPVisible">
        <TranGoods
          :EntpGoodsId="goodsId"
          :Type="type"
          @closeDialog="closeTranAPDialog"
        ></TranGoods>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="关联商品信息"
      :visible.sync="searchAPVisible"
      width="1000px"
    >
      <div v-if="searchAPVisible">
        <SearchGoods
          :EntpGoodsId="goodsId"
          :Type="type"
          @closeDialog="closeSearchAPDialog"
        ></SearchGoods>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="type == 0 || type == 2 ? '供应商信息' : '客户信息'"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <div class="dialog-content" v-if="dialogVisible">
        <EntityEdit
          :releEntpId="orderData.ReleEntpId"
          :type="1"
          @closeDialog="closeEntityDialog"
          :source="type == 0 || type == 2 ? 2 : 1"
        ></EntityEdit>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="type == 0 || type == 2 ? '关联供应商信息' : '关联客户信息'"
      :visible.sync="dialogReleVisible"
      width="1000px"
    >
      <div v-if="dialogReleVisible">
        <ReleEntpEntity
          :releEntpId="orderData.ReleEntpId"
          :source="type == 0 || type == 2 ? 2 : 1"
          @closeDialog="closeReleDialog"
        ></ReleEntpEntity>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="配件信息"
      :visible.sync="APMsgVisible"
      width="1000px"
    >    
      <div v-if="APMsgVisible">    
        <APMsg
          :dialogFormVisible="APMsgVisible"
          :EntpTempGoodsId="EntpTempGoodsIdEdit"
          @closeDialog="closeAPMsgDialog"
        ></APMsg>
      </div>
    </el-dialog>     
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import TranGoods from "@/components/entpUnion/goodsManage/releGoods.vue";
import SearchGoods from "@/components/entpUnion/goodsManage/searchGoods.vue";
import mixin from "@/mixins/mixin";
import EntityEdit from "@/components/entpUnion/entityManage/entityEdit";
import ReleEntpEntity from "@/components/entpUnion/entityManage/releEntpEntity";
import APMsg from "@/components/common/APMsg";
export default {
  mixins: [mixin],
  name: "",
  components: {
    breadcrumb,
    TranGoods,
    EntityEdit,
    SearchGoods,
    ReleEntpEntity,
    APMsg,
  },
  data() {
    return {
      loading: false,
      orderData: {},
      tranAPVisible: false,
      dialogVisible: false,
      dialogReleVisible: false,
      searchAPVisible: false,
      APMsgVisible: false,
      entpCusId: "",
      id: "",
      type: 0,
      dataList: [],
      title: "",
      permission: {},
      goodsId: "",
      total: 0,
      multipleSelection: [],
      EntpTempGoodsIdEdit: "",
    };
  },
  mounted() {
    this.permission = this.$util.getPermission("AutoPartsManage");
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    switch (+this.type) {
      case 0:
        this.title = "销售";
        break;
      case 1:
        this.title = "采购";
        break;
      case 2:
        this.title = "销售售后";
        break;
      case 3:
        this.title = "采购售后";
        break;
    }
    this.getOrderDetail();
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route(to, from) {
      this.id = this.$route.query.id;
      this.type = this.$route.query.type;
      switch (+this.type) {
        case 0:
          this.title = "销售";
          break;
        case 1:
          this.title = "采购";
          break;
        case 2:
          this.title = "销售售后";
          break;
        case 3:
          this.title = "采购售后";
          break;
      }
      this.getOrderDetail();
    },
  },
  methods: {
    // 获取详情
    getOrderDetail() {
      this.loading = true;
      this.$util
        .axiosGet({
          url: "/api/EntpUnions/GetEntpOrderDetails",
          data: {
            OrderId: this.id,
            Type: this.type,
          },
          hideLoading: true,
        })
        .then((res) => {
          let data = res.data;
          this.orderData = data;
          this.dataList = data.DetailList;
          for (let index = 0; index < data.DetailList.length; index++) {
            this.total +=
              Number(data.DetailList[index].Price) *
              Number(data.DetailList[index].Count);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 4) {
          sums[index] = "合计：";
          return;
        }
        if (index === 5 || index === 7) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = sums[index].toFixed(2) * 1;
          } else {
            sums[index] = "";
          }
        }
      });
      sums[8] = this.total.toFixed(2);
      return sums;
    },
    closeTranAPDialog(isEdit) {
      this.tranAPVisible = false;
      if (isEdit) this.getOrderDetail();
    },
    tranGoods(goods) {
      if (goods) {
        if (goods.IsHaveSameCode) {
          this.$confirm(
            "检测到您有相同的编码，是否继续提取，创建新的配件商品",
            "提示",
            {
              confirmButtonText: "确定继续提取",
              cancelButtonText: "去关联",
              type: "warning",
              center: false,
            }
          )
            .then(() => {
              this.tranAPVisible = true;
              this.goodsId = goods.GoodsId;
            })
            .catch(() => {
              this.searchAPVisible = true;
              this.goodsId = goods.GoodsId;
            });
        } else {
          this.tranAPVisible = true;
          this.goodsId = goods.GoodsId;
        }
      }
    },
    closeSearchAPDialog(isEdit) {
      this.searchAPVisible = false;
      if (isEdit) this.getOrderDetail();
    },
    releGoods(goods) {
      if (goods) {
        this.searchAPVisible = true;
        this.goodsId = goods.GoodsId;
      }
    },
    reReleGoods(goods) {
      if (goods) {
        this.$confirm("您确定要重新进行商品关联吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "不了",
          type: "warning",
          center: false,
        })
          .then(() => {
            this.searchAPVisible = true;
            this.goodsId = goods.GoodsId;
          })
          .catch(() => {});
      }
    },
    closeEntityDialog(isEdit) {
      this.dialogVisible = false;
      if (isEdit) this.getOrderDetail();
    },
    tranEntps() {
      this.dialogVisible = true;
    },
    releEntps() {
      this.dialogReleVisible = true;
    },
    reReleEntps() {
      this.$confirm("您确定要重新进行企业信息的关联吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "不了",
        type: "warning",
        center: false,
      })
        .then(() => {
          this.dialogReleVisible = true;
        })
        .catch(() => {});
    },
    closeReleDialog(isEdit) {
      this.dialogReleVisible = false;
      if (isEdit) this.getOrderDetail();
    },
    tranOrders() {
      if (!this.multipleSelection[0]) {
        this.$util.warningMsg("请选择商品，再进行转化");
        return;
      }

      for (let index = 0; index < this.multipleSelection.length; index++) {
        let isRele = this.multipleSelection[index].IsRele;
        if (!isRele) {
          this.$util.warningMsg("请先将所有商品进行关联后，再进行转化");
          return;
        }
      }

      this.$util.setLocalStorage("UnionTansOrder", this.multipleSelection);
      switch (+this.type) {
        case 0: //销售   对应  跳转要转化成采购页面
          this.$router.push(
            "/entpFriend/orderManage/tranPurOrders?orderId=" +
              this.id +
              "&entpCusId=" +
              this.orderData.EntpCusId +
              "&entpCusName=" +
              this.orderData.EntpCusName +
              "&releType=0"
          );
          break;
        case 1: //采购   对应  跳转要转化成销售页面
          this.$router.push(
            "/entpFriend/orderManage/tranSaleOrders?orderId=" +
              this.id +
              "&entpCusId=" +
              this.orderData.EntpCusId +
              "&entpCusName=" +
              this.orderData.EntpCusName +
              "&releType=1"
          );
          break;
        case 2: //销售售后   对应  跳转要转化成采购售后页面
          this.$router.push(
            "/entpFriend/orderManage/tranPurReturns?orderId=" +
              this.id +
              "&entpCusId=" +
              this.orderData.EntpCusId +
              "&entpCusName=" +
              this.orderData.EntpCusName +
              "&releType=2" +
              "&return=" +
              this.orderData.SurplusMoney
          );
          break;
        case 3: //采购售后   对应  跳转要转化成销售售后页面
          this.$router.push(
            "/entpFriend/orderManage/tranSaleReturns?orderId=" +
              this.id +
              "&entpCusId=" +
              this.orderData.EntpCusId +
              "&entpCusName=" +
              this.orderData.EntpCusName +
              "&releType=3" +
              "&return=" +
              this.orderData.SurplusMoney
          );
          break;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    showAPMsgDialog(id) {
      if (id) {
        this.EntpTempGoodsIdEdit = id;
        this.APMsgVisible = true;
      }
    },
    closeAPMsgDialog() {
      this.APMsgVisible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.search-ctn {
  border: 1px solid @border3Color;
  padding-top: 10px;
  margin-bottom: 10px;

  .el-form-item {
    margin-bottom: 10px;
  }
}
.form-main {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: auto;
}
.form-bottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  div {
    width: 50%;
  }
}
.share-content {
  .el-form-item {
    margin-bottom: 0px;
  }
}
.section-title {
  display: flex;
  justify-content: space-between;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  font-weight: bold;
  font-size: @font-sm;
  margin-left: -1px;
  background: @border3Color;
}
.edit-ctn {
  .div-table-cell {
    padding: 0 5px;
  }
}
.option-content {
  display: flex;
  line-height: 30px;

  .project-Name {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 12px;
  }
}
.business-content-main {
  min-width: 1000px;
}
.table-main {
  position: relative;
}
.div-table-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0px;
  }
}
.apcode-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .info-icon {
    margin-right: 10px;
  }
}
.tag {
  margin-left: 8px;
}
.bottom-div {
  .ship-amount {
    text-align: right;
    margin-bottom: 10px;
    .discount-count {
      font-size: 15px;
      font-weight: bold;
      color: #f00;
    }
  }
  .part {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
  .subzone {
    .dismoney {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 32px;
    }
    .discount-count {
      font-size: 15px;
      font-weight: bold;
      color: #f00;
    }
  }
}
.el-table {
  margin-bottom: 15px;
}
.el-icon-warning-outline {
  color: orange;
  margin-right: 3px;
}
</style>